import { useEffect } from "react";

import { trackEvent } from "@/setup/events";

export const useTrackCompanySearched = (query: string) => {
  useEffect(() => {
    if (query.length > 0) {
      trackCompanySearched(query);
    }
  }, [query]);
};

const trackCompanySearched = (query: string) => {
  trackEvent("Company Searched", { query });
};
